/*
  Modal filter on Search Result Details
*/
//@flow
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import {
  Modal,
  Col,
  Row,
  Container,
  Collapse,
  Input,
  FormGroup
} from 'reactstrap';

import IconClose from '../../images/tutup-button.png';
import ButtonApply from '../../images/ButtonApply.png';

import 'rc-slider/assets/index.css';

import { getAllBrands, getAllSizes } from '../../actions/filterAction';
import {
  filteringSearchResult,
  clearBeforeFiltering,
  doFilteringSearchToApi
} from '../../actions/productAction';
/*
type Funct = (any:any, any2:any, any3:any) => void
type Props = {
  dataProduct:Object,
  dataFilter:Object,
  getAllBrands:Funct,
  getAllSizes:Funct,
  doFilteringSearchToApi:Funct,
  filteringSearchResult:Funct,
  clearBeforeFiltering:Funct,
  history:Object,
  match:Object,
  toggleModalSearch:Funct,
  active:boolean,
}
type State = {
  brandId:Array<number>,
  sizeIdMale:Array<Object>,
  sizeIdFemale:Array<Object>,
  sizeIdKids:Array<Object>,
  categorySize:string,
  maxPrice:string,
  minPrice:string,
  gender:string,
  collapseMale:boolean,
  collapseFemale:boolean,
  collapseKids:boolean,
  kondisi:string
}
*/

class ModalFilterAndSort extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      brandId: [],
      sizeIdMale: [],
      sizeIdFemale: [],
      sizeIdKids: [],
      categorySize: '',
      maxPrice: '',
      minPrice: '',
      kondisi: '',
      gender: '',
      collapseMale: false,
      collapseFemale: false,
      collapseKids: false,
    };
    this.handleApplyFilter = this.handleApplyFilter.bind(this);
    this.toggleMale = this.toggleMale.bind(this);
    this.toggleFemale = this.toggleFemale.bind(this);
    this.toggleKids = this.toggleKids.bind(this);
    this.handlePriceFilter = this.handlePriceFilter.bind(this);
    this.handlePickSizes = this.handlePickSizes.bind(this);
    // this.setTimeout = this.setTimeout.bind(this);
  }

  handlePriceFilter(e) {
    const lastState= this.state;
    lastState[e.target.name]=e.target.value;
    this.setState({
      ...lastState
    });

  }

  componentDidUpdate() {
    if (this.state.sizeIdMale.length === 0 && this.state.categorySize !== '') {
      this.setState({
        categorySize: ''
      })
    }
  }

  onChangeFiltering() {
    let filterQueries = 'sizes=4,5,7.5&size_types=M,M,L&brands=2,4&availables=true&start_price=1000&end_price=2000'
    let pattern = `sizes=[]`
  }

  onChangesSizes(size, id_size, category) {
    const currentSize = category === 'M' ? this.state.sizeIdMale :
                        category === 'F' ? this.state.sizeIdFemale :
                        this.state.sizeIdKids
    let adaNgga = currentSize.map((a, index) => {
      return a
    }).indexOf(size)

    if (adaNgga === -1) {
      currentSize.push(size);
      if (category === 'M') {
        this.setState({
          sizeIdMale: currentSize
        })
      } else if (category === 'F') {
        this.setState({
          sizeIdFemale: currentSize
        })
      } else {
        this.setState({
          sizeIdKids: currentSize
        })
      }
    } else {
      let checkFirst = currentSize.filter((item, index) => {
        return item != size
      })

      if (category === 'M') {
        this.setState({
          sizeIdMale: checkFirst,
        })
      } else if (category === 'F') {
        this.setState({
          sizeIdFemale: checkFirst,
        })
      } else {
        this.setState({
          sizeIdMale: checkFirst,
        })
      }
    }
  }

  onChangeBrand(brandId) {
    let currentBrand = this.state.brandId;
    let adaNgga = currentBrand.map((a, index) => {
      return a
    }).indexOf(brandId);

    if (adaNgga === -1) {
      currentBrand.push(brandId);
      this.setState({
        brandId: currentBrand
      });
    } else {
      let checkFirst = currentBrand.filter((item, index) => {
        return item != brandId
      })
      this.setState({
        brandId: checkFirst
      })
    }

  }

  handlePickSizes(size, id_size, category) {

    const { maleSizes, femaleSizes, kidsSizes } = this.props.dataFilter.sizes;
    const currentSize = category === 'M' ? this.state.sizeIdMale :
                        category === 'F' ? this.state.sizeIdFemale :
                        this.state.sizeIdKids

    const bigArr = category === 'M' ? maleSizes.data :
                 category === 'F' ? femaleSizes.data :
                 kidsSizes

    let adaNgga = currentSize.map((a, index) => {
      return a.US
    }).indexOf(size)
    let isAble = false;
    if (adaNgga == -1) {
      isAble = true;
      for (let i = 0; i < bigArr.length; i++) {
        if (bigArr[i].US === size) {
          currentSize.push(bigArr[i])
        }
      }
      if (category === 'M') {
        this.setState({
          sizeIdMale: currentSize,
        })
      } else if (category === 'F') {
        this.setState({
          sizeIdFemale: currentSize,
        })
      } else {
        this.setState({
          sizeIdKids: currentSize,
        })
      }
    } else {
      let checkFirst = currentSize.filter((item, index) => {
        return item.US != size
      })

      if (category === 'M') {
        this.setState({
          sizeIdMale: checkFirst,
        })
      } else if (category === 'F') {
        this.setState({
          sizeIdFemale: checkFirst,
        })
      } else {
        this.setState({
          sizeIdKids: checkFirst,
        })
      }
    }
  }

  manipulateSize() {
    let male = this.state.sizeIdMale
    let female = this.state.sizeIdFemale
    let kids = this.state.sizeIdKids;
    let category = [];
    let finalSizes = [];
    for (let i = 0; i < 3; i++) {
      if (i === 0) {
        for (let j = 0; j < male.length; j++) {
          category.push('M');
        }
      } else if (i === 1) {
        for (let j = 0; j < female.length; j++) {
          category.push('F');
        }
      } else {
        for (let j = 0; j < this.state.sizeIdKids.length; j++) {
          category.push('K');
        }
      }
    }

    for (let i = 0; i < 3; i++) {
      if (i === 0) {
        if(male.length !== 0) {
          finalSizes.push(`${male.join(',')}`);
        } else {
          finalSizes.splice(0, 1);
        }
      } else if (i === 1) {
        if(female.length !== 0) {
          finalSizes.push(`${female.join(',')}`);
        } else {
          finalSizes.splice(1, 1);
        }
      } else {
        if(kids.length !== 0) {
          finalSizes.push(`${kids.join(',')}`);
        } else {
          finalSizes.splice(2, 1);
        }
      }
    }

    let fixSizes = {
      size: finalSizes,
      category: category.join(',')
    }
    return fixSizes;
  }

  manipulateBrand() {
    if (this.state.brandId.length !== 0) {
      let brandPath = this.state.brandId
      return brandPath;
    }
    return []
  }

  manipulatePrice() {
    let price = [];
    if (this.state.minPrice !== '') price.push(`start_price=${this.state.minPrice}`);
    if (this.state.maxPrice !== '') price.push(`&end_price=${this.state.maxPrice}`);
    if (this.state.minPrice === '' && this.state.maxPrice !== '') price.push(`&start_price=0`);
    if (this.state.maxPrice === '') price.splice(1, 1);
    return price;
  }

  handleApplyFilter() {
    const { pathname } = this.props.history.location
    const { searchKeyword } = this.props.dataProduct;
    let searchKeywordFilter =  this.props.match.params.keyword === undefined ? '' : this.props.match.params.keyword.toUpperCase();
    let pattern = [];
    let sizes = this.manipulateSize();
    let brand = this.manipulateBrand();
    let prices = this.manipulatePrice();

    if (brand.length) {
      let pathBrand = brand.join(',');
      pattern.push(`brands=${pathBrand}&`);
    }
    if (sizes.size.length) {
      let pathSize = sizes.size.join(',');
      pattern.push(`sizes=${pathSize}&size_types=${sizes.category}&`)
    }
    if (prices.length) pattern.push(prices.join(''))
    if (this.state.kondisi !== '') {
      pattern.push(`&sneakers_condition=${this.state.kondisi}`)
    }
    let filterQueries = pattern.join('');
    this.props.history.push({pathname, search: filterQueries}); //this one
    this.props.toggleModalSearch();
    
    //this one
    if (searchKeywordFilter.toUpperCase() === 'BROWSE+ALL' || searchKeywordFilter.toUpperCase() === 'BROWSE+ALL') {
      // alert('Tanpa keyword');
      this.props.doFilteringSearchToApi(filterQueries, {
        params: {
          page: 1,
          availables: true
        }
      }, '');
    } else {
      if (searchKeywordFilter === '') {
        this.props.doFilteringSearchToApi(filterQueries, {
          params: {
            page: 1,
            availables: true
          }
        }, '');
      } else {
        let keywordFix = searchKeywordFilter.replace(/\+/g, ' ').trim();
        this.props.doFilteringSearchToApi(filterQueries, {
          params: {
            keyword: keywordFix,
            page: 1,
            availables: true
          }
        }, '');
      }
    }
  }

  toggleMale() {
    let { collapseFemale, collapseKids } = this.state;
    if (true) {
      this.setState({ collapseMale: !this.state.collapseMale });
    }
  }

  toggleFemale() {
    let { collapseKids, collapseMale } = this.state;
    if (true) {
      this.setState({ collapseFemale: !this.state.collapseFemale });
    }
  }

  toggleKids() {
    let { collapseFemale, collapseMale } = this.state;
    if (true) {
      this.setState({ collapseKids: !this.state.collapseKids });
    }
  }

  handleClearDefault() {
    this.setState({
      brandId: [],
      sizeIdMale: [],
      sizeIdFemale: [],
      sizeIdKids: [],
      categorySize: '',
      maxPrice: '',
      minPrice: '',
      gender: '',
      collapseMale: false,
      collapseFemale: false,
      collapseKids: false,
    })
  }

  render () {
    let { collapseFemale, collapseMale } = this.state;
    return (
      <Modal
				size="100"
				className="search-custom-modal modal-fullscreen"
				modalClassName="modal-search"
				wrapClassName="wrapper-search"
				contentClassName="content-search content__filter"
				backdropClassName="backdrop-search-content"
				fade={false}
				isOpen={this.props.active} toggle={this.props.toggleModalSearch}>
				<div className="wrapper-modal-active filter__modal">
					<Container className="active__title__wrap">
						<Row>
							<Col className="item-modal-active">
                <Container className="active__brand__wrap">
                  <div className="item__filter">
                    <p onClick={() => this.handleClearDefault() }>Clear</p>
                  </div>
                </Container>
							</Col>
              <Col className="item-modal-active">
                <div className="title__modal__filter">
                  <h3>FILTER</h3>
                </div>
							</Col>
							<Col className="item-modal-active">
                {/* <p className="btn-close-modal" onClick={this.toggleModalSearch}>Kembali</p> */}
                {/* <div onClick={this.props.toggleModalSearch} style={{ padding: '1.5rem'}}>

                  <KickImage className="btn-close-modal close-modal_filter"  src={IconClose} alt=""/>
                </div> */}
								{/* <p className="btn-close-modal" onClick={this.toggleModalSearch}>Kembali</p> */}
                <KickImage className="btn-close-modal close-modal_filter" onClick={this.props.toggleModalSearch} src={IconClose} alt="close"/>
							</Col>
						</Row>
					</Container>

          <Container className="active__brand__wrap">
            <div className="item__filter">
              <h3>Brand</h3>
              <Row>
              {
                  this.props.dataFilter.brands.length === 0 ?
                  <Col md="2" sm="4" xs="4"><p>Loading...</p></Col>
                  :
                  this.props.dataFilter.brands.map((a, index) => (
                    <Col
                      onClick={() => this.onChangeBrand(a.id)}
                      key={index} md="2" sm="4" xs="4">
                      <p className={
                        this.state.brandId.map(item => {
                          return item
                        }).indexOf(a.id) > -1 ? `selected_brand` : ``
                      }>{ a.name }</p>
                    </Col>

                  ))
                }
              </Row>
            </div>
          </Container>
          <Container className="active__brand__wrap">
            <div className="item__filter">
              <h3>Size (US)</h3>
              <Row className="sizes__grouping">
                <Col md="3" sm="4" xs="6"
                  onClick={() => this.toggleMale() }>
                  <p className={ this.state.gender === 'M'? `selected_brand` : ``}>Pria</p>
                </Col>
                <Collapse isOpen={this.state.collapseMale}>
                  <Row>
                    <div className="grid__size">
                      {
                        this.props.dataFilter.sizes.maleSizes.noDuplicate.length === 0 ?
                        <p>Loading...</p>
                        :
                        this.props.dataFilter.sizes.maleSizes.noDuplicate.map((a, index) => (
                          <p
                            onClick={ () => this.onChangesSizes(a.US, a.id, 'M') }
                            className={
                              this.state.sizeIdMale.map(item => {
                                return item
                              }).indexOf(a.US) > -1 ? `selected_brand` : ``
                            }
                            key={index}>{ a.US }
                          </p>
                        ))
                      }
                    </div>
                  </Row>
                </Collapse>
                <Col md="3" sm="4" xs="6"
                  onClick={() => this.toggleFemale() }>
                  <p className={ this.state.gender === 'F'? `selected_brand` : ``}>Wanita</p></Col>
                  <Collapse isOpen={this.state.collapseFemale}>
                    <Row>
                      <div className="grid__size">
                        {
                          this.props.dataFilter.sizes.femaleSizes.noDuplicate.length === 0 ?
                          <p>Loading...</p>
                          :
                          this.props.dataFilter.sizes.femaleSizes.noDuplicate.map((a, index) => (
                            <p
                              onClick={ () => this.onChangesSizes(a.US, a.id, 'F') }
                              className={
                                this.state.sizeIdFemale.map(item => {
                                  return item
                                }).indexOf(a.US) > -1 ? `selected_brand` : ``
                              }
                              key={index}>{ a.US }
                            </p>
                          ))
                        }
                      </div>
                    </Row>
                  </Collapse>
                <Col md="3" sm="4" xs="6"
                  onClick={() => this.toggleKids() }>
                  <p className={ this.state.gender === 'K'? `selected_brand` : ``}>Anak/GS</p>
                </Col>
                <Collapse isOpen={this.state.collapseKids}>
                  <Row>
                    <div className="grid__size">
                      {
                        this.props.dataFilter.sizes.kidsSizes.length === 0 ?
                        <p>Loading...</p>
                        :
                        this.props.dataFilter.sizes.kidsSizes.map((a, index) => (
                          <p
                            onClick={ () => this.onChangesSizes(a.US, a.id, 'K') }
                            className={
                              this.state.sizeIdKids.map(item => {
                                return item
                              }).indexOf(a.US) > -1 ? `selected_brand` : ``
                            }
                            key={index}>{ a.US }
                          </p>
                        ))
                      }
                    </div>
                  </Row>
                </Collapse>
              </Row>
            </div>
          </Container>
          <Container className="active__brand__wrap">
            <div className="item__filter">
              <h3>Kondisi</h3>
              <Row>
                <Col
                  md="3" sm="4" xs="6"
                  onClick={() => this.setState({
                    kondisi: 'new'
                  })}
                >
                  <p
                    className={this.state.kondisi === 'new' ? 'selected_brand' : ''}
                  >BARU</p>
                </Col>
                <Col
                  md="3" sm="4" xs="6"
                  onClick={() =>this.setState({
                    kondisi: 'used'
                  })}>
                    <p
                      className={this.state.kondisi === 'used' ? 'selected_brand' : ''}
                    >BEKAS</p>
                </Col>
                <Col
                  md="3" sm="4" xs="6"
                  onClick={() => this.setState({
                    kondisi: 'pre_order'
                  })}>
                    <p
                      className={this.state.kondisi === 'pre_order' ? 'selected_brand' : ''}
                    >PRE-ORDER</p>
                </Col>
                <Col
                  md="3" sm="4" xs="6"
                  onClick={() => this.setState({
                    kondisi: 'pre_verified'
                  })}>
                    <p
                      className={this.state.kondisi === 'pre_verified' ? 'selected_brand' : ''}
                    >EXPRESS</p>
                </Col>
              </Row>
            </div>
          </Container>
          <Container className="active__brand__wrap">
            <div className="item__filter">
              <h3>Harga</h3>
              <Row className="kondisi__grouping">
                <Col md="3" sm="4" xs="6"><p>dalam rupiah</p></Col>
              </Row>
            </div>
            <div className="container__picker__price">
              {/* <SliderPicker /> */}
              <Row>
                <Col md="6" sm="12" xs="12">
                  <div className="filter_input__price">
                    <p>Minimal</p>
                    <FormGroup>
                      <Input
                        name="minPrice"
                        value={this.state.minPrice}
                        onChange={this.handlePriceFilter }
                      />
                    </FormGroup>
                  </div>
                </Col>
                <Col md="6" sm="12" xs="12">
                  <div className="filter_input__price">
                    <p>Maksimal</p>
                    <Input
                      name="maxPrice"
                      value={this.state.maxPrice}
                      onChange={this.handlePriceFilter }
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                {/* <Col md="6" style={{ textAlign: 'left', padding: 0 }}>
                  <p>{ convertToRupiah(Number(this.state.minPrice))}</p>
                </Col>
                <Col md="6" style={{ textAlign: 'right', padding: 0 }}>
                  <p>{ convertToRupiah(Number(this.state.maxPrice))}</p>

                </Col> */}
              </Row>
            </div>
          </Container>
          <Container className="active__brand__wrap">
            <div className="item__filter wrapper__btn__grid">
              <h3></h3>
              <Row className="item__grid">
                {/* <Col md="4" sm="4" xs="4"></Col> */}
                <Col>
                  <div className="container__btn__apply">
                    <KickImage
                      style={{ width: '100%', cursor: 'pointer' }}
                      className="btn-apply-filter" onClick={this.handleApplyFilter } src={ButtonApply} alt="apply filter"/>
                  </div>
                </Col>
                {/* <Col md="4" sm="4" xs="6"></Col> */}
              </Row>
            </div>
          </Container>
				</div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  dataProduct: state.dataProduct,
  dataFilter: state.filterReducer,
})

const mapDistpatchToProps = dispatch => {
  return {
    getAllBrands:() => dispatch(getAllBrands()),
    getAllSizes:() => dispatch(getAllSizes()),
    doFilteringSearchToApi: (params, page, action) => dispatch(doFilteringSearchToApi(params, page, action)),
    filteringSearchResult:(params) => dispatch(filteringSearchResult(params)),
    clearBeforeFiltering:() => dispatch(clearBeforeFiltering()),
  }
}

export default connect(mapStateToProps, mapDistpatchToProps)(ModalFilterAndSort);
